import { Global, css } from '@emotion/react';
import { theme } from './theme';
import OpticianSans from '../fonts/OpticianSans/Webfont/Web-TT/Optiker-K.ttf';

export const GlobalStyle = (props) => (
  <Global
    {...props}
    styles={css`
      @font-face {
        font-family: 'OpticianSans';
        src: url(${OpticianSans}) format('woff');
      }
      html,
      body,
      div,
      span,
      applet,
      object,
      iframe,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      blockquote,
      pre,
      a,
      abbr,
      acronym,
      address,
      big,
      cite,
      code,
      del,
      dfn,
      em,
      img,
      ins,
      kbd,
      q,
      s,
      samp,
      small,
      strike,
      strong,
      sub,
      sup,
      tt,
      var,
      b,
      u,
      i,
      center,
      dl,
      dt,
      dd,
      ol,
      ul,
      li,
      fieldset,
      form,
      label,
      legend,
      table,
      caption,
      tbody,
      tfoot,
      thead,
      tr,
      th,
      td,
      article,
      aside,
      canvas,
      details,
      embed,
      figure,
      figcaption,
      footer,
      header,
      hgroup,
      menu,
      nav,
      output,
      ruby,
      section,
      summary,
      time,
      mark,
      audio,
      video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
      }
      /* HTML5 display-role reset for older browsers */
      article,
      aside,
      details,
      figcaption,
      figure,
      footer,
      header,
      hgroup,
      menu,
      nav,
      section {
        display: block;
      }
      body {
        line-height: 1;
      }
      ol,
      ul {
        list-style: none;
      }
      blockquote,
      q {
        quotes: none;
      }
      blockquote:before,
      blockquote:after,
      q:before,
      q:after {
        content: '';
        content: none;
      }
      table {
        border-collapse: collapse;
        border-spacing: 0;
      }
      html {
        font-family: ${theme.fonts.sansSerif};
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        width: 100%;
        height: 100%;
      }
      body {
        margin: 0;
        font-family: ${theme.fonts.sansSerif};
        width: 100vw !important;
        max-width: 100% !important;
        overflow: hidden !important;
        overflow-y: auto !important;
        ${props.bodyLock === true
          ? `
            overflow: hidden;
            height: 100vh;
            position: fixed;
            width: 100%;
          `
          : null};
      }
      h1,
      h2,
      h3,
      h4,
      h5 {
        font-family: ${theme.fonts.sansSerif};
        font-weight: 400;
      }
    `}
  />
);

export default GlobalStyle;
